import type { ReactNode } from 'react';
import type { Role } from '@avisoma/shared';
import { ChevronDownIcon } from '@heroicons/react/24/outline';
import { FaExclamationTriangle } from 'react-icons/fa';
import AuthGuard from '../AuthGuard';

interface Props {
  expanded: boolean;
  onToggle: () => void;
  authRole?: Role;
  children: ReactNode;
}

export function DangerZoneCard({ expanded, onToggle, authRole = 'admin', children }: Props) {
  return (
    <AuthGuard role={authRole}>
      <div className="mt-4 bg-zinc-100 sm:rounded-lg overflow-hidden dark:bg-zinc-800">
        <button
          onClick={onToggle}
          className="w-full px-4 py-5 sm:p-6 flex items-center justify-between hover:bg-gray-50 focus:outline-none dark:hover:bg-zinc-800"
        >
          <h3 className="text-lg font-medium text-red-600 flex items-center dark:text-red-400 gap-2">
            {expanded && <FaExclamationTriangle className="h-5 w-5" />} Danger Zone
          </h3>
          <ChevronDownIcon
            className={`h-5 w-5 text-gray-400 dark:text-zinc-400 transition-transform ${
              expanded ? 'rotate-180' : ''
            }`}
          />
        </button>
        {expanded && (
          <div className="px-4 py-5 sm:p-6 border-t border-gray-200 dark:border-zinc-700">
            <div className="mt-2">
              <p className="text-sm text-gray-500 dark:text-zinc-400 mb-4">
                These actions cannot be undone. Please be certain.
              </p>
              <div className="space-y-4">{children}</div>
            </div>
          </div>
        )}
      </div>
    </AuthGuard>
  );
}
